import { ThemePerformanceParams } from '@api/api/theme-overview';
import { useGetV7ThemePerformance } from '@terminal/react-query-hooks/themes/useGetV7ThemePerformance';
import { useMemo } from 'react';

export const useGetThemePerformance = (
  params?: ThemePerformanceParams,
  enabled = true
) => {
  const activeThemePerformance = useGetV7ThemePerformance(params, enabled);

  const themes = useMemo(
    () => activeThemePerformance.data?.pages?.flatMap(p => p.themes),
    [activeThemePerformance.data]
  );

  return {
    ...activeThemePerformance,
    themes,
    hasAnyError: activeThemePerformance.isError,
  };
};
